<template>
    <div class="warpper-div edit-card-wrapper">
        <div v-if="[0, 2].includes(pageType)">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px">
                <div class="title"> {{ $t('client.role.roleInformation') }} </div>
                <el-form-item :label="$t('client.role.roleName') + '：'" prop="name">
                    <el-input v-model="ruleForm.name" maxlength="32"></el-input>
                </el-form-item>
                <el-row>
                    <el-col :span="16">
                        <el-form-item :label="$t('client.role.roleDescription') + '：'" prop="description">
                            <el-input type="textarea" show-word-limit v-model="ruleForm.description"
                                maxlength="60"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="title sys-split-line"> {{ $t('client.role.clientAuthority') }}</div>

                <MenuTreeConfig ref="menuTreeConfigRef" :setDisabledAttr="false"></MenuTreeConfig>

            </el-form>

            <MyFormBtn @handleSave="handleSave"></MyFormBtn>
        </div>
        <RoleDetail :dataForm="ruleForm" @updateType="updateType" v-else></RoleDetail>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import RoleDetail from './roleDetail.vue'
import MenuTreeConfig from '@/components/menuTreeConfig.vue'
import MyFormBtn from '@/components/myFormBtn.vue'
export default {
    data() {
        return {
            brandId: 0,
            monitorId: Number(Cookies.get("monitorId")),
            pageType: 0,
            ruleForm: {
                name: null,
                description: null,
            },
            rules: {
                name: [{ required: true, message: vm.$t('common.commontip'), trigger: 'blur' }],

            },
        }
    },
    components: {
        RoleDetail,
        MyFormBtn,
        MenuTreeConfig
    },
    created() {
    },
    async mounted() {
        let name = this.$route.name;
        let { id } = this.$route.params;
        if (name === 'roleAdd') {
            this.pageType = 0;
            let brandId = Number(this.$route.query.brandId);
            this.ruleForm.brandId = brandId;
            this.$refs.menuTreeConfigRef.initDataList(this.$Api.rolePermissionTree + '/' + this.monitorId + '/' + brandId + '/0');
        } else if (['roleEdit', 'roleDetail'].includes(name)) {
            this.pageType = name === 'roleDetail' ? 1 : 2;
            this.ruleForm.id = id;
            await this.getRoleDetail();
            if (this.pageType === 2) {
                this.$refs.menuTreeConfigRef.initDataList(this.$Api.rolePermissionTree + '/' + this.monitorId + '/' + this.ruleForm.brandId + '/' + this.ruleForm.id);
            }
        }
    },
    methods: {
        async getRoleDetail() {
            let res = await this.$Http.get(`${this.$Api.role}/${this.monitorId}/${this.ruleForm.id}`);
            if (res.success) {
                this.ruleForm = Object.assign({ id: this.ruleForm.id }, res.result);
            }
        },
        updateType() {
            this.pageType = 2;
            this.$nextTick(() => {
                this.$refs.menuTreeConfigRef.initDataList(this.$Api.rolePermissionTree + '/' + this.monitorId + '/' + this.ruleForm.brandId + '/' + this.ruleForm.id);
            });
        },
        goBackClick() {
            this.$router.go(-1);
        },
        handleSave() {
            this.$refs.ruleForm.validate((valid) => {
                if (!valid) {
                    return false;
                } else {
                    let url = this.$Api.role + '/' + this.monitorId
                    this.ruleForm.permissionIds = this.$refs.menuTreeConfigRef.getCheckedData();
                    if (this.ruleForm.id) {
                        this.$Http.put(url, this.ruleForm).then(res => {
                            if (res.success) {
                                this.$message.success(vm.$t('common.successful'));
                                this.goBackClick();
                            }
                        });
                    } else {
                        this.$Http.post(url, this.ruleForm).then(res => {
                            if (res.success) {
                                this.$message.success(vm.$t('common.successful'));
                                this.goBackClick();
                            }
                        });
                    }
                }
            });
        },
    },

}
</script>

<style scoped lang="scss">
.warpper-div {
    position: relative;
}

.warpper-div .el-input,
.warpper-div .el-input__inner {
    width: 232px;
}
</style>

<style lang="scss">
.warpper-div {
    .el-form-item {
        margin-bottom: 20px !important;
    }
}
</style>